import {Component, ContentChild} from '@angular/core';
import {AssignmentConfig, MxAssignmentGrid, MxAssignmentGridCustomizerEvent, MxGridCustomizerEvent} from 'mx-core';
import {PrlProductTypesComponent} from '../prl-product-types/prl-product-types.component';

@Component({
    selector: 'prl-product-type-assignment',
    template: `
        <mx-assignment-grid-dialog (customize)="onCustomize($event)">
            <prl-product-type (customize)="onCustomizeGrid($event)" #selectionComponent></prl-product-type>
        </mx-assignment-grid-dialog>
    `,
    standalone: false,
    providers: [{provide: MxAssignmentGrid, useExisting: PrlProductTypeAssignmentComponent}]
})

export class PrlProductTypeAssignmentComponent extends MxAssignmentGrid {
    @ContentChild('selectionComponent') selectionComponent: PrlProductTypesComponent;

    assignmentConfig: AssignmentConfig = {
        title: 'Product Types',
        keyField: 'id',
        displayField: 'name'
    };

    onCustomize(event: MxAssignmentGridCustomizerEvent): void {
        event.customizeAssignmentDialog(this.assignmentConfig);
    }

    onCustomizeGrid(event: MxGridCustomizerEvent): void {
        event.customizeRestUrl('/product-types/with-products');
    }
}
